// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList,
  StatsGraph
}                         from '../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';
import styles      from './style';
import ReactTable from "react-table";

class ExpenseDetails extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    const search = props.location.search; // returns the URL query String
    const params = new URLSearchParams(search);
    this.state = {
      venue: props.statsTable.revenue_per_month.requested_venue_id,
      date: params.get('date'),
      category: params.get('category'),
      expense_data: [],
      expense_headers: []
    };
    
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
    this.getExpenses();
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
        fetchStatsGraphDataIfNeeded
      }
    } = this.props;
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  getExpenses() {
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=5104&venue_id=${this.state.venue}&category=${this.state.category}&date=${this.state.date}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({expense_data:data.data,expense_headers:data.headers})
           // alert("fix");
       }).catch(error => error);
  }

  getTrProps = (state, rowInfo, instance) => {
      return {
        style: {
          background:'white',
          color:'black'
        }
      };
    };


  renderExpenses(){
   
    var headers = []
    if(this.state.expense_data.length > 0){
      headers = Object.keys(this.state.expense_data[0])
    }
    
    const headings = this.state.expense_headers.map(function(element,index){
      var heading = {};
      heading["name"] = element;
      heading["accessor"] = index.toString();//For react-table
      heading["displayName"] = element;
      heading["Header"] = element; //For react-table
      heading["sortable"] = true;
      heading["inputFilterable"] = true;
      heading["visible"] = (element.indexOf("_hidden") == -1);
      heading["show"] = (element.indexOf("_hidden") == -1);
      heading["render"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;
      heading["Cell"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;// Custom cell components for react-table
      return heading;
    });

    return(
             
      <div className='col-md-12 table_container1 table-responsive' style={styles.table}>
        <div className="heading heading2 left" style={styles.header}>Expense Details</div> 
        { this.state.expense_data.length > 0 ?
        <ReactTable  
          data={this.state.expense_data}  
          columns={headings}  
          defaultPageSize = {100}  
          pageSizeOptions = {[100,200,500]} 
          filterable={true}
          showPagination={this.state.expense_data.length > 100}
          showPaginationTop = {this.state.expense_data.length > 100}
          style = {{background:'#ddd'}}
          getTrProps = {this.getTrProps}
          defaultFilterMethod = {(filter, row, column) => {
            const id = filter.pivotId || filter.id
            return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
          }}
                     
          >
          {
                //To show the record count on top  
                (state, makeTable, instance) => {

                  let recordsInfoText = "";

                  const { filtered, pageRows, pageSize, sortedData, page } = state;

                  if (sortedData && sortedData.length > 0) {
                    let isFiltered = filtered.length > 0;

                    let totalRecords = sortedData.length;

                    let recordsCountFrom = page * pageSize + 1;

                    let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                    if (isFiltered){
                      recordsInfoText = `${totalRecords} filtered records`;
                    }
                    else {
                      recordsInfoText = `${totalRecords} records`;
                    }
                  } else {
                      recordsInfoText = "No records";
                    }
                  return (
                    <div className="main-grid" style={{background:'#ddd'}}>
                      <div className="above-table text-right">
                        <div className="col-sm-12 records-info">
                          <span className="">{recordsInfoText}</span>
                        </div>
                      </div>
                      {makeTable()}
                      
                    </div>

                  );
                }
              }
          </ReactTable>
          :
          this.state.expense_headers.length > 0 ?
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> No Data Available</div>
            </div>
            :
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
            </div>
        }
      </div>
      )
  }

  render() {
    

    const {
      statsTable,
      scoreCard,
      statsGraph,
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;
    
    console.log('props data',this.state.game_type)
    console.log('revenue_data',this.state.revenue_data)
    return(
      <div>
        
        <div>
             <div className="breadcrumps" style={{marginBottom:'2%'}}>
                        <a href={'/#/expenses'} >
                          <span>Expense</span>
                        </a> 
                        <a onClick={()=>this.props.history.goBack()} >
                          <span>Daily Expense</span>
                        </a>
                        <a>
                          <span>Expense Details</span>
                        </a>  
          </div>
          {this.renderExpenses()}
        </div>
      </div>
    );
  }
}

export default ExpenseDetails;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/expenseDetails/ExpenseDetails.js